import gsap from 'gsap';
import { Sizes } from '../utils';

export class Anchor {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			target: options.target,
			duration: options.duration || 0.5,
			offset: options.offset || 0,
		};
		this.isEnable = false;

		this.clickFuncs = [];
	}

	init() {
		if ( ! this.elements?.length ) return;
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.elements.forEach( ( item, index ) => {
				this.clickFuncs[ index ] = () => this.#click();
				item.addEventListener( 'click', this.clickFuncs[ index ] );
			} );
			this.isEnable = true;
		}
	}

	kill() {
		this.elements.forEach( ( item, index ) => {
			item.removeEventListener( 'click', this.clickFuncs[ index ] );
			this.clickFuncs[ index ] = null;
		} );
		this.clickFuncs = [];
		this.isEnable = false;
	}

	resize() {
		if ( this.isEnable ) {
			this.kill();
		}
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.init();
		}
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.clickFuncs = null;
		this.isEnable = null;
	}

	#click() {
		gsap.to( window, {
			scrollTo: {
				y: this.options.target,
				offsetY: this.options.offset,
			},
			duration: this.options.duration,
		} );
	}
}
